import { Pipe, PipeTransform } from '@angular/core';
import { RuoliUtente } from '@hm_app/@core/models/utente';


export function labelRuoloUtente(ruolo: RuoliUtente | string, plurale: boolean = false) {
    if (plurale) {
        switch (ruolo) {
            case RuoliUtente.superadmin: return 'SuperAdmins';
            case RuoliUtente.admin: return 'Admins';
            case RuoliUtente.mes: return 'MES';
            case RuoliUtente.medico_generico: return 'Medici di famiglia';
            case RuoliUtente.medico_ginecologo: return 'Medici Ginecologi';
            case RuoliUtente.ostetrica: return 'Ostetriche/ci';
            case RuoliUtente.user: return 'Utenti';
            case RuoliUtente.user_arpa: return 'Utenti';
            case RuoliUtente.operatore: return 'Operatori';
            default: return ruolo;
        }

    }
    switch (ruolo) {
        case RuoliUtente.superadmin: return 'SuperAdmin';
        case RuoliUtente.admin: return 'Admin';
        case RuoliUtente.mes: return 'MES';
        case RuoliUtente.medico_generico: return 'Medico di famiglia';
        case RuoliUtente.medico_ginecologo: return 'Medico Ginecologo';
        case RuoliUtente.ostetrica: return 'Ostetrica/o';
        case RuoliUtente.user: return 'Utente';
        case RuoliUtente.user_arpa: return 'Utente';
        case RuoliUtente.operatore: return 'Operatore';
        default: return ruolo;
    }
}

@Pipe({
    name: 'ruoloUtente',
})
export class RuoloUtentePipe implements PipeTransform {

    transform(ruolo: RuoliUtente | string, plurale?: boolean): string {
        return labelRuoloUtente(ruolo, plurale);
    }
}
